import { useQuery } from "@tanstack/react-query";
import { getClientDeals } from "@/api";
import { useViewer } from "@/contexts";
import { Deal } from "@/types";

export const useClientDeals = () => {
  const { clientId } = useViewer();

  const query = useQuery<Deal[]>({
    queryKey: ["clientDeals", clientId],
    queryFn: () => getClientDeals(clientId),
    enabled: !!clientId,
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};
